import React, { Component } from "react";
import { formatNumber } from "../../utils/formatting";
import {
  loading,
  NavbarCustomer,
  t,
  Select
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class AssetReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_category: "All Categories",
      filter_status: "All Status",
      filter_location: "All Locations",

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
      summary: {
        total: 48,
        total_change: "+8% vs previous",
        completed: 42,
        completed_rate: "87.5% completion",
        in_progress: 4,
        in_progress_rate: "8.3% of total",
        pending: 2,
        pending_rate: "4.2% of total",
      },
      // -----------------------------------
      // Mock Data: SLA Metrics by Category
      // -----------------------------------
      data: [
        {
          category: "HVAC",
          total: 18,
          avgResponse: "45 min",
          avgResolution: "4.2 hrs",
          responseSla: "98%",
          resolutionSla: "94%",
          breaches: 1,
        },
        {
          category: "Electrical",
          total: 12,
          avgResponse: "30 min",
          avgResolution: "3.5 hrs",
          responseSla: "100%",
          resolutionSla: "92%",
          breaches: 1,
        },
        {
          category: "Plumbing",
          total: 8,
          avgResponse: "55 min",
          avgResolution: "2.8 hrs",
          responseSla: "95%",
          resolutionSla: "100%",
          breaches: 0,
        },
        {
          category: "Mechanical",
          total: 10,
          avgResponse: "40 min",
          avgResolution: "5.1 hrs",
          responseSla: "96%",
          resolutionSla: "85%",
          breaches: 1,
        },
      ],

      // -----------------------------------
      // Mock Data: SLA Breach Details
      // -----------------------------------
      breachDetails: [
        {
          id: "SR-2025-032",
          date: "Feb 5, 2025",
          category: "HVAC",
          type: "Resolution",
          target: "8 hours",
          actual: "12 hours",
          reason: "Parts unavailable",
        },
        {
          id: "SR-2025-028",
          date: "Jan 28, 2025",
          category: "Electrical",
          type: "Resolution",
          target: "4 hours",
          actual: "6 hours",
          reason: "Technician delay",
        },
        {
          id: "SR-2025-019",
          date: "Jan 15, 2025",
          category: "Mechanical",
          type: "Resolution",
          target: "8 hours",
          actual: "14 hours",
          reason: "Complex repair",
        },
      ],
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { summary, data, breachDetails } = this.state;

    return (
      <div
        className="w-100 min-vh-100 pb-5"
        style={{ backgroundColor: "#F4F7FE" }}
      >
        <NavbarCustomer />
        <div className="body px-4 mt-3">
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">
              {t("sla_performance_report")}
            </h3>
            <div className="text-secondary text-14">
              {t("sla_metrics_desc")}
            </div>
          </div>

          {/* Filter Bar */}
          <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-end gap-3 border border-light">
            <div className="flex-grow-1" style={{ minWidth: "200px" }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">
                {t("period")}
              </label>
              <Select
                  className="form-control rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none"
                  options={[{ value: "", label: t("this_month") }]}
                  value=""
                  onChange={() => {}}
                  placeholder={t("this_month")}
                  default={false}
              />
            </div>
            <div className="flex-grow-1" style={{ minWidth: "200px" }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">
                {t("sla_type")}
              </label>
              <Select
                  className="form-control rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none"
                  options={[{ value: "", label: t("all_types") }]}
                  value=""
                  onChange={() => {}}
                  placeholder={t("all_types")}
                  default={false}
              />
            </div>
            <div className="flex-grow-1" style={{ minWidth: "200px" }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">
                {t("priority")}
              </label>
              <Select
                  className="form-control rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none"
                  options={[{ value: "", label: t("all_priorities") }]}
                  value=""
                  onChange={() => {}}
                  placeholder={t("all_priorities")}
                  default={false}
              />
            </div>
            <button
              className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center"
              style={{ height: "42px" }}
            >
              <span className="icon me-2">{"\uf0b0"}</span> {t("apply_filters")}
            </button>
          </div>

          {/* KPI Summary Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-primary rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-primary text-12 fw-bold mb-1">
                  {t("overall_sla")}
                </div>
                <h2 className="fw-bold text-dark mb-1">{formatNumber(summary.total)}</h2>
                <div className="progress" style={{ height: "6px" }}>
                  <div
                    className="progress-bar"
                    style={{ width: "94.2%", backgroundColor: "#2D9C8B" }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-success rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-success text-12 fw-bold mb-1">
                  {t("response_sla")}
                </div>
                <h2 className="fw-bold text-dark mb-1">{formatNumber(summary.completed)}</h2>
                <div className="text-success text-10 fw-bold">
                  {t("target")}: 95%
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-warning rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-warning text-12 fw-bold mb-1">
                  {t("resolution_sla")}
                </div>
                <h2 className="fw-bold text-dark mb-1">
                  {summary.in_progress}
                </h2>
                <div className="text-warning text-10 fw-bold">
                  {t("target")}: 95%
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-danger rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-danger text-12 fw-bold mb-1">
                  {t("sla_breaches")}
                </div>
                <h2 className="fw-bold text-dark mb-1">{formatNumber(summary.pending)}</h2>
                <div className="text-danger text-10 fw-bold">
                  {t("this_period")}
                </div>
              </div>
            </div>
          </div>

          {/* Graphs Area */}
          <div className="row g-4 mb-4">
            <div className="col-lg-8">
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                <h6 className="fw-bold text-dark mb-4">{t("sla_trend")}</h6>
                <div
                  className="d-flex align-items-center justify-content-center bg-light rounded-3"
                  style={{ height: "250px" }}
                >
                  <span className="text-secondary opacity-50">
                    [ Area Chart Placeholder ]
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                <h6 className="fw-bold text-dark mb-4">
                  {t("sla_by_priority")}
                </h6>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: "250px" }}
                >
                  <div className="position-relative d-flex align-items-center justify-content-center">
                    <div
                      className="rounded-circle border border-5 border-success"
                      style={{ width: "150px", height: "150px" }}
                    ></div>
                    <div className="position-absolute icon text-success text-24">
                      {"\uf200"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Details Table */}
          <div className="card border-0 rounded-4 shadow-sm pb-2 overflow-hidden bg-white mb-4">
            <div className="p-4 border-bottom border-light">
              <h6 className="fw-bold text-dark mb-0">
                {t("sla_metrics_by_category")}
              </h6>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light bg-light bg-opacity-50">
                    <th className="py-3 px-4 border-0">{t("category")}</th>
                    <th className="py-3 border-0">{t("total_requests")}</th>
                    <th className="py-3 border-0">{t("avg_response")}</th>
                    <th className="py-3 border-0">{t("avg_resolution")}</th>
                    <th className="py-3 border-0">{t("response_sla")}</th>
                    <th className="py-3 border-0">{t("resolution_sla")}</th>
                    <th className="py-3 border-0">{t("breaches")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light">
                      <td className="py-3 px-4 fw-bold text-dark text-13">
                        {item.category}
                      </td>
                      <td className="text-secondary text-13">{formatNumber(item.total)}</td>
                      <td className="text-secondary text-13">
                        {item.avgResponse}
                      </td>
                      <td className="text-secondary text-13">
                        {item.avgResolution}
                      </td>
                      <td>
                        <span className="badge bg-success-light text-success rounded-pill px-3 py-1 fw-bold text-10 border border-success">
                          {item.responseSla}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge bg-${parseInt(item.resolutionSla) < 90 ? "warning" : "success"}-light text-${parseInt(item.resolutionSla) < 90 ? "warning" : "success"} rounded-pill px-3 py-1 fw-bold text-10 border`}
                        >
                          {item.resolutionSla}
                        </span>
                      </td>
                      <td className="text-secondary text-13 fw-bold">
                        {item.breaches}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* SLA Breach Details Table */}
          <div className="border border-danger rounded-4 overflow-hidden">
            <div className="p-3" style={{ backgroundColor: "#FFF5F5" }}>
              <h6 className="fw-bold text-danger mb-0 text-13">
                <span className="icon me-2">{"\uf071"}</span>{" "}
                {t("sla_breach_details")}
              </h6>
            </div>
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr className="text-secondary text-11 fw-bold bg-light bg-opacity-25">
                    <th className="py-3 px-4 border-0">{t("request_id")}</th>
                    <th className="py-3 border-0">{t("date")}</th>
                    <th className="py-3 border-0">{t("category")}</th>
                    <th className="py-3 border-0">{t("breach_type")}</th>
                    <th className="py-3 border-0">{t("target")}</th>
                    <th className="py-3 border-0">{t("actual")}</th>
                    <th className="py-3 border-0">{t("reason")}</th>
                  </tr>
                </thead>
                <tbody>
                  {breachDetails.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light">
                      <td className="py-3 px-4 fw-bold text-danger text-13">
                        {item.id}
                      </td>
                      <td className="text-secondary text-13">{item.date}</td>
                      <td className="text-secondary text-13">
                        {item.category}
                      </td>
                      <td>
                        <span className="badge bg-danger-light text-danger rounded-pill px-3 py-1 fw-bold text-10 border border-danger">
                          {item.type}
                        </span>
                      </td>
                      <td className="text-secondary text-13">{item.target}</td>
                      <td className="text-secondary text-13">{item.actual}</td>
                      <td className="text-secondary text-13 fw-medium">
                        {item.reason}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Actions */}
          {/* <div className="d-flex justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border border-light">
            <div className="text-secondary text-12">
              {t("report_generated")}: Feb 19, 2026 at 10:30 AM
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-white border px-3 py-2 text-danger fw-bold rounded-3 d-flex align-items-center shadow-none">
                <span className="icon me-2">{"\uf1c1"}</span> {t("export_pdf")}
              </button>
              <button className="btn btn-white border px-3 py-2 text-success fw-bold rounded-3 d-flex align-items-center shadow-none">
                <span className="icon me-2">{"\uf1c3"}</span>{" "}
                {t("export_excel")}
              </button>
              <button className="btn btn-primary px-4 py-2 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center">
                <span className="icon me-2">{"\uf02f"}</span>{" "}
                {t("print_report")}
              </button>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}
